<template>
  <div>
    <base-header type="gradient-warning" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
      <div class="row">
        <!-- Chamadas ativas -->
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Batch de startups STARS"
            type="gradient-green"
            :sub-title="
              String(
                stats['Aceleração'].batches + stats['Pré-aceleração'].batches
              )
            "
            icon="fas fa-award"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap">
                <span class="font-weight-bold text-warning">{{
                  stats["Aceleração"].batches
                }}</span>
                de aceleração e
                <span class="font-weight-bold text-warning">{{
                  stats["Pré-aceleração"].batches
                }}</span>
                de pré-aceleração
              </span>
            </template>
          </stats-card>
        </div>
        <!-- Média inscrições aceleração -->
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Startups aceleração"
            type="gradient-red"
            :sub-title="String(stats['Aceleração'].startupsAvg)"
            icon="ni ni-spaceship"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap">em média por batch</span>
            </template>
          </stats-card>
        </div>
        <!-- Média inscrições pré-aceleração -->
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Startups pré-aceleração"
            type="gradient-blue"
            :sub-title="String(stats['Pré-aceleração'].startupsAvg)"
            icon="fas fa-paper-plane"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap">em média por batch</span>
            </template>
          </stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div
            class="card shadow table-container vld-parent"
            ref="batches_table"
          >
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0" v-if="!ofFund">Batches de startups STARS</h3>
                  <h3 class="mb-0" v-else>
                    Batches de startups do fundo
                    <span class="text-orange">{{ ofFund }}</span>
                    <router-link
                      :to="`/admin/fundos/${$route.params.id}/editar`"
                    >
                      <i class="ml-2 fas fa-eye text-sm"></i>
                    </router-link>
                  </h3>
                </div>
                <div class="col text-right">
                  <router-link :to="{ name: 'admin_batches_new' }">
                    <base-button type="primary" size="sm" :custom="true"
                      >Criar novo batch</base-button
                    >
                  </router-link>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <base-table
                class="table align-items-center table-flush"
                thead-classes="thead-light"
                tbody-classes="list"
                :data="tableData"
              >
                <template slot="columns">
                  <th>#</th>
                  <th>Nome</th>
                  <th>Categoria</th>
                  <th>Fundo</th>
                  <th>Data início</th>
                  <th>Data fim</th>
                  <th>Número de startups</th>
                  <th>Status do batch</th>
                  <th>Ações</th>
                </template>
                <template slot-scope="{ row, index }">
                  <td>
                    <span>{{ index + 1 }}</span>
                  </td>
                  <td>
                    <router-link
                      :to="`/admin/batches/${row.id}/editar`"
                      class="btn btn-link pl-0"
                    >
                      {{ row.name }}
                    </router-link>
                  </td>
                  <td>{{ row.type }}</td>
                  <td>
                    <router-link :to="`/admin/fundos/${row.fund_id}/editar`">{{
                      row.fund.tag
                    }}</router-link>
                  </td>
                  <td>{{ row.start_date }}</td>
                  <td>{{ row.end_date }}</td>
                  <td>
                    <span class="bg-white border rounded py-2 px-3"
                      >{{ row.num_startups }}
                      <i class="ni ni-spaceship ml-1 text-danger"></i
                    ></span>
                  </td>
                  <td>
                    <div class="d-flex align-items-center">
                      <span class="completion mr-2">{{ row.completion }}%</span>
                      <div>
                        <base-progress
                          :type="row.statusInfo.type"
                          :show-percentage="false"
                          class="pt-0"
                          :value="row.completion"
                        />
                      </div>
                      <span class="ml-2" :title="row.statusInfo.description">{{
                        row.statusInfo.name
                      }}</span>
                    </div>
                  </td>
                  <td>
                    <router-link
                      :to="'/admin/batches/' + row.id + '/editar'"
                      class="btn btn-white py-1 px-2"
                      title="Editar batch"
                      ><i class="fas fa-edit text-info"></i
                    ></router-link>
                    <router-link
                      :to="'/admin/batches/' + row.id + '/acompanhamento'"
                      class="btn btn-white py-1 px-2"
                      title="Acompanhar startups"
                      ><i class="fas fa-tasks text-warning"></i
                    ></router-link>
                    <router-link
                      :to="'/admin/fundos/' + row.fund_id + '/editar'"
                      class="btn btn-white py-1 px-2"
                      title="Editar fundo"
                      ><i class="fas fa-coins text-dark-yellow"></i
                    ></router-link>
                  </td>
                </template>
              </base-table>
              <p v-if="empty" class="text-center text-warning mt-3">
                Não há batches cadastrados até o momento
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "batches_table",
  data() {
    return {
      tableData: [],
      ofFund: "",
      batchStatus: [
        {
          key: "open",
          value: "Regular",
          description:
            "Um batch regular fica visível para os investidores cadastrados no fundo e para as startups inseridas no batch.",
        },
        {
          key: "closed",
          value: "Encerrado",
          description:
            "O status 'Encerrado' ficará visível para os investidores cadastrados no fundo e para as startups inseridas no batch.",
        },
        {
          key: "hidden",
          value: "Invisível",
          description:
            "Um batch invisível fica oculto para todos os investidores e startups.",
        },
      ],
      empty: false,
      stats: {
        // eslint-disable-next-line prettier/prettier
        "Aceleração": {
          batches: 0,
          startupsAvg: 0,
        },
        "Pré-aceleração": {
          batches: 0,
          startupsAvg: 0,
        },
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.batches_table,
      width: 90,
      height: 90,
    });
    try {
      let url = "/batches";
      const batchId = this.$route.params.id;
      if (batchId) url = `/funds/${batchId}${url}`;
      const { data } = await api.get(url);
      data.forEach((batch) => {
        batch.completion = this.getCompletion(batch.start_date, batch.end_date);
        batch.start_date = this.formatDate(batch.start_date);
        batch.end_date = this.formatDate(batch.end_date);
        batch.statusInfo = this.getStatusInfo(batch.status, batch.completion);
        if (batchId) this.ofFund = batch.fund.tag;
      });
      if (data.length) {
        this.tableData = data;
        Object.assign(this.stats, this.calcStats());
      } else this.empty = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar os batches");
    }
  },
  methods: {
    getCompletion(start, end) {
      const d1 = this.moment(start);
      const d2 = this.moment(end);
      const today = this.moment();
      if (today.isSameOrAfter(d2, "day")) return 100;
      if (today.isSameOrBefore(d1, "day")) return 0;
      let totalDays = d2.diff(d1, "days");
      let remainingDays = d2.diff(today, "days");
      if (totalDays > 0 && remainingDays > 0)
        return Math.round(Math.abs((1 - remainingDays / totalDays) * 100));
      return 0;
    },
    getStatusInfo(currentStatus, completion) {
      const selectedStatus = this.batchStatus.find(
        (status) => status.key === currentStatus
      );

      let statusInfo = {
        type: "info",
        name: selectedStatus.value,
        description: selectedStatus.description,
      };
      if (completion === 100) statusInfo.type = "success";
      else if (selectedStatus.key === "closed") statusInfo.type = "warning";
      if (selectedStatus.key === "hidden") statusInfo.type = "danger";
      return statusInfo;
    },
    calcStats() {
      const stats = {};
      this.tableData.forEach((batch) => {
        const type = batch.type;
        if (!stats[type])
          stats[type] = {
            batches: 0,
            startupsAvg: 0,
          };
        stats[type].batches++;
        stats[type].startupsAvg += batch.num_startups;
      });
      if (stats["Aceleração"] && stats["Aceleração"].batches > 0) {
        stats["Aceleração"].startupsAvg = Math.round(
          stats["Aceleração"].startupsAvg / stats["Aceleração"].batches
        );
      }
      if (stats["Pré-aceleração"] && stats["Pré-aceleração"].batches > 0) {
        stats["Pré-aceleração"].startupsAvg = Math.round(
          stats["Pré-aceleração"].startupsAvg / stats["Pré-aceleração"].batches
        );
      }
      return stats;
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 150px;
}
</style>
